/**
 * 用户注册模块
 * @author fulh
 * @create 2016-08-19 15:03:38
 */

$.module('MM.user.register', function () {
  var ACTIONS = {
    registerMobile:
      'register/mobile?mobile={mobile}&sms_code={sms_code}&pwd={pwd}&email={email}&event_seq_id={event_seq_id}',
    amberRegister: 'api/v1/registers/mobile',
  };

  // 注册弹出框控制模块
  var $popRegArea;
  var $errorTip;

  function _handleRegister() {
    var data = $.serializeForm($popRegArea);
    var $btn = $popRegArea.find('.btn-register');

    $popRegArea.find('.ui-form-input:focus').blur();

    if ($btn.hasClass('btn-disabled')) {
      // 禁用状态不可点击
      return;
    }

    if ($errorTip.text()) {
      // 存在错误 返回
      return;
    }

    if (!data.sms_code) {
      return $errorTip.text('请输入验证码');
    }

    var pwdTip = MM.user.checkPwd(data.pwd); // 验证密码是否符合要求
    if (pwdTip) {
      return $errorTip.text(pwdTip);
    }

    // if (!$('.login-form-agreement .icon-checkbox-on').length) { // 是否同意 协议
    //     return MM.ui.messager.warn("您还没有同意《么么直播服务使用条款》");
    // }

    var btn_text = $btn.html();
    $btn.addClass('btn-disabled').text('数据提交中……');

    // 上报注册事件
    data.event_seq_id = MM.util.sdata.trackWithSeqId('register', {
      mobile: data.mobile,
      qdname: MM.user.getFrom(),
    });

    // 兼容 fakeMobile 未同步到 mobile 字段的情况
    if (!data.mobile && data.fakeMobile) {
      data.mobile = data.fakeMobile;
    }

    data.terminal_type = 'PC_WEB';

    request.send({
      url: ACTIONS.amberRegister,
      type: 'post',
      urlType: 'amber',
      data: data,
      contentType: 'json',
      success: function (res) {
        // 提交注册请求
        MM.user.setUserOriginToken(res.data.access_token);
        $btn.removeClass('btn-disabled').html('注册成功');
        MM.user.getExtraUserInfo(function () {
          location.reload();
        });
      },
      error: function (res) {
        var errorMsgs = {
          30431: '短信验证码无效',
          30406: '输入短信验证码',
          30411: '密码需同时包含小写字母，大写字母和数字',
          30414: '邮箱已经存在',
          30415: '邮箱格式错误',
        };
        $errorTip.text(
          errorMsgs[res.code] || res.message || '注册失败，请重试',
        );
        $btn.removeClass('btn-disabled').html(btn_text);
      },
    });

    // request.post(ACTIONS.amberRegister, 'amber', data, function(res) { // 提交注册请求
    //     MM.user.setUserOriginToken(res.data.token);
    //     $btn.removeClass('btn-disabled').html("注册成功");
    //     MM.user.getExtraUserInfo(function () {
    //         location.reload();
    //     });
    // }, function(res) {
    //     var errorMsgs = {
    //         30431: '短信验证码无效',
    //         30406: '输入短信验证码',
    //         30411: '密码需同时包含小写字母，大写字母和数字',
    //         30414: '邮箱已经存在',
    //         30415: '邮箱格式错误'
    //     };
    //     $errorTip.text(errorMsgs[_.get(res, 'code')] || '注册失败，请重试');
    //     $btn.removeClass('btn-disabled').html(btn_text);
    // });
  }

  function _goRegister() {
    window.location.href =
      '/?action=register&referrer=' + encodeURIComponent(location.href);
  }

  function _popupRegister(typeObject, option) {
    MM.user.popup.show(typeObject || 'registerForm', function ($popup) {
      $popRegArea = $popup.find('.register-form-content');
      $errorTip = $popRegArea.find('.error-tip');

      var opt = {
        // 渲染 短信 组件
        $wrapper: $popRegArea.find('.login-form-sms'),
        $errorTip: $errorTip,
        $submitBtn: $popRegArea.find('.register-btn'),
        type: 1,
        saText: '注册',
        geetKey: 'register',
        checkRepeat: true,
        typeObject: typeObject,
        tokenInfo: option || {},
      };

      if (typeObject === 'safeCheck') {
        $popRegArea = $popup.find('.safe-check-content');
        opt.$wrapper = $popRegArea.find('.login-form-sms');
        opt.$errorTip = $popRegArea.find('.error-tip');
        opt.saText = '';
        opt.geetKey = 'verifyMobile';
      } else {
        MM.ui.component.renderPasswordInput({
          // 渲染密码框组件
          $wrapper: $popRegArea.find('.login-form-password'),
          placeholder: '设置密码（需包含数字和字母，8-20位）',
          name: 'pwd',
        });
        $popRegArea
          .find('.smscode-code-btn')
          .attr('data-sawebclick', 'id=tc007b003&desc=发送验证码')
          .before('<i class="iconfont icon-guanbi1 clear-code"></i>');
      }

      MM.ui.smscode.render(opt);

      _bindEvents(typeObject);
    });
  }

  function _bindEvents(typeObject) {
    $popRegArea
      .on('keyup', 'input', function (e) {
        // 兼容 回车提交请求
        if (e.keyCode !== 13) return;
        $(this).blur();
        if (typeObject !== 'safeCheck') {
          _handleRegister();
        }
      })
      .on('focus', 'input[name="pwd"]', function () {
        // 清空提示信息
        $errorTip.text('');
      })
      .on('click', '.btn-register', function (e) {
        // 点击注册按钮
        _handleRegister();
      })
      .on('click', '.clear-code', function (e) {
        // 点击 清空按钮
        $(this).siblings('input').val('');
      })
      .on('blur', '.ui-form-input', function (e) {
        var $this = $(this);
        var val = $this.val();
        var name = $this.attr('name');
        var tipText = '';
        switch (name) {
          case 'sms_code':
            if (!val.length && !$('.mobile-input').val()) {
              tipText = '请输入验证码';
            }
            break;
          case 'pwd':
            if (!val.length) {
              tipText = '请设置密码';
            } else {
              tipText = MM.user.checkPwd(val);
            }
            break;
        }
        tipText && $errorTip.text(tipText);
      })
      .on('submit', 'form', function (e) {
        e.preventDefault();
      });
  }

  return {
    goRegister: _goRegister,
    popupRegister: _popupRegister,
  };
});
